// العناوين الجديدة (domeinApp.nl.ts). النسخة العربية.
export const appDomeinAr = {
    company: {
        title: 'بيانات الشركة',
        kvk: 'السجل التجاري (KvK) {kvk}',
        contact: 'التواصل',
        where: 'التطبيق على {app} واللوحة على الحائط على {board}. سجّل الدخول فقط على {app}.',
    },
    /** Oude beginscherm-app van f.amumin.com: weg, en {app} opnieuw op het beginscherm. */
    homeScreen: 'هل كان AMUMIN على شاشتك الرئيسية؟ احذف الأيقونة القديمة وأضف {app} إلى الشاشة الرئيسية من جديد. على iPhone أو iPad تعمل الإشعارات فقط من الشاشة الرئيسية.',
    push: {
        title: 'الإشعارات متوقفة في هذا المتصفح',
        body: 'أصبح AMUMIN الآن على amumin.app. تُفعَّل الإشعارات لكل عنوان على حدة، لذلك يجب تفعيلها في هذا المتصفح مرة أخرى. هل تريد أن تصلك الإشعارات هنا من جديد؟',
        action: 'تفعيل الإشعارات',
        later: 'ليس الآن',
        done: 'الإشعارات مفعّلة من جديد.',
        denied: 'هذا المتصفح يحظر الإشعارات. يمكنك السماح بها من إعدادات المتصفح.',
    },
};
//# sourceMappingURL=domeinApp.ar.js.map